/**
 * SSOT-43 / #10167 / #10486 — warn when RHC toggles CLIA testing off (491.9(c)(2)).
 */

const CLIA_CONDITION_SLUGS = new Set([
  "rural_health_clinic",
  "rhc",
]);

export const CLIA_OFF_WARNING_RHC =
  "Turning off CLIA-regulated testing conflicts with the RHC certification condition in 42 CFR § 491.9(c)(2) (basic laboratory services on-site). Confirm this facility truly has no on-site lab before saving.";

export function slugNeedsCliaCertificationCondition(
  facilityTypeSlug: string | null | undefined,
): boolean {
  const slug = String(facilityTypeSlug ?? "")
    .trim()
    .toLowerCase();
  return CLIA_CONDITION_SLUGS.has(slug);
}

export function shouldWarnCliaTestingOff(
  facilityTypeSlug: string | null | undefined,
  fieldValues: Record<string, unknown>,
): boolean {
  if (!slugNeedsCliaCertificationCondition(facilityTypeSlug)) return false;
  const raw = fieldValues["performs_clia_regulated_testing"];
  if (raw === false || raw === "false" || raw === 0 || raw === "0") return true;
  if (raw && typeof raw === "object" && "value" in (raw as object)) {
    const v = (raw as { value: unknown }).value;
    return v === false || v === "false" || v === 0 || v === "0";
  }
  return false;
}
